import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsWithoutCompanies } from 'application/store/slices/accountSlice/selectors';

export const useAccountIsWithoutCompanies = () => {
  const isWithoutCompanies = useAppSelector(selectIsWithoutCompanies);

  return isWithoutCompanies;
};
